// Hileadzz
import Models from './hileadzz/models.yml'
import deModels from './hileadzz/models.de.yml'
import Errors from './hileadzz/errors.yml'
import deErrors from './hileadzz/errors.de.yml'
import Ui from './hileadzz/ui.yml'
import deUi from './hileadzz/ui.de.yml'
import Datetime from './hileadzz/datetime.yml'
import deDatetime from './hileadzz/datetime.de.yml'
import Statistics from './hileadzz/statistics.yml'
import deStatistics from './hileadzz/statistics.de.yml'
import Routes from './hileadzz/routes.yml'

// Talents
import enTalModels from './talents/models.en-tal.yml'
import deTalModels from './talents/models.de-tal.yml'
import enTalErrors from './talents/errors.en-tal.yml'
import deTalErrors from './talents/errors.de-tal.yml'
import enTalUi from './talents/ui.en-tal.yml'
import deTalUi from './talents/ui.de-tal.yml'
import enTalStatistics from './talents/statistics.en-tal.yml'
import deTalStatistics from './talents/statistics.de-tal.yml'
import talRoutes from './talents/routes.yml'

export default [
  Routes,
  talRoutes,
  Models,
  deModels,
  enTalModels,
  deTalModels,
  Errors,
  deErrors,
  enTalErrors,
  deTalErrors,
  Ui,
  deUi,
  enTalUi,
  deTalUi,
  Datetime,
  deDatetime,
  Statistics,
  deStatistics,
  enTalStatistics,
  deTalStatistics
]



//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/index.js
// module id = 674
// module chunks = 0